import React, { useState, useEffect, useRef } from "react";
import item from "./Asset/88.PNG"
// import item from "./Asset/code.webp"
import vid from "./Asset/read.mp4"
import vid1 from "./Asset/vfa.mp4"
import mvid from "./Asset/vfa.mp4"
import st from "./Asset/st.mp4"
import gbd from "./Asset/art.jpg"
import v from "./Asset/v.mp3"
import { Link, useNavigate } from "react-router-dom";
import { FaUserFriends, FaStore, FaChartBar, FaQrcode, FaVolumeUp, FaVolumeMute, } from 'react-icons/fa';
import { IoColorPalette, IoExtensionPuzzleOutline } from "react-icons/io5";
import Contact from "./Contact/Contact";
import Part from "./Paterners/Part";
import AppStoreBanner from "./AppStoreBanner/AppStoreBanner";
import { SlArrowDown } from "react-icons/sl";
import Shop from "./Shop";
import firebase from "../firebaseConfig";
import ScrollToTop from "./ScrollToTop";
import Leaderboard from "./Leaderboard";
import Cookies from "../Cookies";
import Form from "./Form";
import CusCall from "../CusCall";
import Footer2 from "./Footer2";
import Websites from "./WebPages/Websites";
import OkuProfile from "./OkuProfile";
import Socials from "./Socials";
import ProfessionAnimation from "./ProAnimation";



const Hero = ({ }) => {
    const [inputValue, setInputValue] = useState("");
    const [Read, setRead] = useState(false);
    const navigate = useNavigate();

    const [theme, setTheme] = useState(
      localStorage.getItem("theme") ? localStorage.getItem("theme") : "dark"
      // localStorage.getItem("theme") ? localStorage.getItem("theme") : "light"
    );
// console.log(theme)

    const currentURL = `${window.location.origin}/`;


  const handleClaimLinktree = () => {
    // Pass the input value to the Register component
    navigate(user ? '/profile' : "/register", { state: { username: inputValue } });
    window.scrollTo(0, 0)
  };

  
  const [user, setUser] = useState(null);

  const [CSuser, setCSUser] = useState();
  useEffect(() => {
    
    // Check if user data exists in local storage
    const userData = localStorage.getItem("userData");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup the event listener on unmount
  }, []);


  const FeatureCard = ({ Icon, title, description }) => (
    <div className="bg-white dark:bg-gray-600 text-start shadow-lg rounded-lg p-6 lg:w-96 mx-auto ">
      <div className="flex items-center justify-center w-12 h-12 rounded-full mx-auto mb-4">
        <Icon className="text-purple-600 text-8xl" />
      </div>
      <h3 className="text-3xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-600 dark:text-gray-300">{description}</p>
    </div>
  );

  const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    const togglePlay = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0; // Reset audio to the start when stopped
            } else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

  return (
    <div className="dark:bg-gradient-to-r from-black to-stone-700 bg-white h-screen grid w-[100%]">

<span id="about"></span>
      {/* Main Content */}
      {/* <div className="lg:hidden pt-[190%] flex" /> */}

      {/* <div style={{ display: "flex", alignItems: "center" }} className="text-white">
            <audio ref={audioRef} src={v} loop />
            <button
                onClick={togglePlay}
                style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "24px",
                }}
                className="absolute z-50 lg:top-32 top-28 lg:left-40 left-5"
            >
                {isPlaying ? <FaVolumeUp />  : <FaVolumeMute />}
            </button>
        </div> */}
      {/* <div className=" flex flex-col lg:flex-row gap-10 text-start self-center absolute lg:mt-28 mt-48">
      <div className=" align-middle">
          <div 
          className="text-white p-8 rounded-2xl text-center shawdow-2xl max-w-lg"
          // className="text-white lg:bg-[rgba(52,52,52,0.3)] mt-16 dark:bg-[rgba(52,52,52,0.3)] p-8 rounded-2xl text-center shawdow-2xl max-w-lg"
          >
            <p className="mt-0 font-bold text-6xl lg:text-8xl">Oku's Office </p>
            <p className="mt-3 text-3xl lg:text-5xl text-center">Wear-to-Earn<span className="text-[#aaa]">™</span></p>
          </div>

          <div 
  className="text-white flex self-center items-center justify-center text-[60px] animate-bounce"
>
  <SlArrowDown />
</div>

      
         
      <div className="mt-2 mb-10 flex flex-col items-center">

       <button onClick={handleClaimLinktree} className="px-12 font-semibold shadow-md py-2 outline-none bg-gradient-to-r from-blue-600 to-gray-300 text-white rounded-full h-12 lg:h-14">
          Start Earning
        </button>
      </div>

      </div>
     </div> */}

      {/* Input Field */}

      
            <div className="dark:bg-gradient-to-r from-black to-stone-700 w-[100%] pb-0 lg:mt-40 mt-24 lg:py-0">
              {/* <div className="bg-[#780016] w-[100%] pb-10 lg:py-20"> */}
              
              {/* <div className="bg-white text-center justify-center shadow-lg self-center flex justify-self-center -mt-[30%] lg:-mt-[10%] lg:w-[60%] h-60 w-[80%] lg:h-64">
                        
                          <h1 className="text-center p-2 font-bold text-gray-600">PARTNERS</h1>
  
                </div> */}
                
                <div className="flex flex-col lg:flex-row justify-center items-center text-center lg:mx-20 align-middle">
  
                  <div className="dark:text-[#fff] text-[#000] font-bold lg:w-[50%] text-start align-middle p-10 pt-0">
                      <p className=" text-9xl font-bold lg:text-9xl">
                    Hi I'm 
                      </p>
                      <p className=" text-9xl font-bold lg:text-9xl">
                    Oku
                      </p>
                      
                      <p className="dark:text-[#fff] text-[#000] mt-6 ml-3 text-sm max-w-md font-bold ">
                      <ProfessionAnimation />
                      </p>
                      {/* <button
                       className="bg-black dark:bg-gradient-to-r from-blue-600 to-gray-300 shadow-xl px-10 p-4 mx-3 mt-5 rounded-full text-white hover:scale-110 duration-500 font-bold">Wear to Earn</button> */}
                   </div>
  
                 <div
  // style={{width: '100%'}}
  className="w-[100%] lg:w-[50%] h-[100%] justify-center items-center flex object-cover"
  dangerouslySetInnerHTML={{
    __html: `<video  style="
        position: relative;
    width: 100%;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
    padding: 5px;
    // z-index: -1;" 
    autoplay loop muted playsinline>
    <source src=${st} type="video/mp4" />
    Your browser does not support the video tag.
    </video>`
  }}
  // <source src=${"https://web-video-resource.gentlemonster.com/assets/stories/jentle-salon/teasing/main/video-src-pc.mp4"} type="video/mp4" />
/>  
                </div>
  
              </div>
              <Socials />

        

                       {/* <span id="top"></span> */}
                       {/* <img src={item} className="rounded-md self-center animate-slowBounce" alt="" /> */}

            


     


{/* <AppStoreBanner /> */}


     {/* <div className=" w-[100%] ">
              
                
                <div className="flex flex-col lg:flex-row justify-center self-center items-center text-center gap-10 mx-4 my-10 align-middle">
  
                  <div className=" self-center justify-center items-center text-center">
                      
<img src={m2} className=" " alt="Dark Mode Logo" />

                  </div>
  
                  <div className=" self-center justify-center items-center text-center">
               
                        <img src={m1} className=" " alt="Light Mode Logo" />
                
                   </div>
  
                </div>
  
              </div>

               */}

<div className="dark:bg-gradient-to-r from-black to-stone-700 w-[100%] pb-0 lg:py-0">
              {/* <div className="bg-[#780016] w-[100%] pb-10 lg:py-20"> */}
              
              {/* <div className="bg-white text-center justify-center shadow-lg self-center flex justify-self-center -mt-[30%] lg:-mt-[10%] lg:w-[60%] h-60 w-[80%] lg:h-64">
                        
                          <h1 className="text-center p-2 font-bold text-gray-600">PARTNERS</h1>
  
                </div> */}
                
                <div className="flex flex-col lg:flex-row justify-center items-center text-center lg:mx-20 align-middle">
  
                <img
              className=" lg:h-96 lg:w-96 h-60 w-60 rounded-full mx-auto"
              src={"https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/1716142298356.jpeg?alt=media&token=f567c5fb-51d5-438b-8327-fe571ac2c17e"}
              alt="Profile Picture"
            />
                  <div className="dark:text-[#fff] text-[#000] font-bold lg:w-[50%] text-start align-middle p-10 pt-5">
                      <p className=" text-2xl font-bold lg:text-4xl">
                    A Full-Stack Engineer/Blockchain, 3D & NFC/AI Innovator
                      </p>
                      
                      <p className="dark:text-[#fff] text-[#000] mt-6 max-w-md font-normal ">
                      A Detail-driven Engineer, passionate about translating concepts into impactful digital solutions and crafting user-centric Web & Mobile applications
                                            <br />
                      <br />

My skills include, but are not limited to: JavaScript, TypeScript, React.js, Next.js, MobX, TailwindCSS, Node.js, Nest.js, PostgreSQL, (Supabase, Firebase, NeonDB, MongoDB) GraphQL, Hasura, Solidity, ethers.js, viem, API Development, CI/CD, and Git.
                      <br />
                                          </p>
                      {/* <button
                       className="bg-black dark:bg-gradient-to-r from-blue-600 to-gray-300 shadow-xl px-10 p-4 mx-3 mt-5 rounded-full text-white hover:scale-110 duration-500 font-bold">Wear to Earn</button> */}
                   </div>
  
                </div>
  
              </div>

<span id="top"></span>
               <Websites />
               <OkuProfile />



           
<div className=" w-[100%] dark:bg-gradient-to-r from-black to-stone-700 bg-white">

<div className="dark:text-white  w-[100%]">
<div className="dark:text-white justify-center items-center lg:flex ">
<div
  // style={{width: '100%'}}
  className="w-[100%] lg:w-[50%] h-[100%] justify-center items-center flex object-cover"
  dangerouslySetInnerHTML={{
    __html: `<video  style="
        position: relative;
    width: 100%;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
    padding: 5px;
    // z-index: -1;" 
    autoplay loop muted playsinline>
    <source src=${vid} type="video/mp4" />
    Your browser does not support the video tag.
    </video>`
  }}
  // <source src=${"https://web-video-resource.gentlemonster.com/assets/stories/jentle-salon/teasing/main/video-src-pc.mp4"} type="video/mp4" />
/>

  <div>

<h2 className="text-2xl font-bold ">Get Started</h2>
<p className="px-5  text-sm">Simply by tapping the Oku's Office logo on your garment</p>
<p className=" text-sm mb-5 text-gray-500">Make Friends. Earn Points. Claim Rewards.</p>
  </div>


  </div>

  </div>
              {/* <Shop title={'me'} /> */}

              {/* <Leaderboard /> */}
  </div>

         


<div className=" w-[100%]">

          <Contact />
            {/* <Part/> */}
</div>
     {/* <Part /> */}

     {/* <Form title={'me'}/> */}


         

        {/* <div className="bg-gray-50 dark:bg-gray-700 dark:text-white w-[100%] py-12 text-center items-center px-6">

          <h1 className="lg:text-6xl text-4xl font-bold text-center p-2">You never have to change <br className=" hidden lg:inline" /> the link in your bio again</h1>
          <p className="mb-20 text-start lg:text-center text-md p-5">Back in 2016 Digital Twin solved social media’s most annoying problem: only having one link in your bio. <br />
             Culture Club was the first ‘link in bio’ platform made to solve this problem. <br /> NYCC has since become so much more. 
             Allowing businesses or creators to get more out of their social media, <br /> grow their following, 
            easily take payments and take back control of how your content is discovered.</p>
          <div className="max-w- text-start mx-auto grid grid-cols-1 md:grid-cols-3 gap-4">
            <FeatureCard
              Icon={FaUserFriends}
              title="Grow your followers across all your social platforms"
              description="Give your followers easy access to all of your content in one simple link. Now everything you do is just one tap away!"
            />
            <FeatureCard
              Icon={FaStore}
              title="Sell products & monetize your audience"
              description="Sell your products, take payments, and even include 'support me' links to let your audience support, tip or donate."
            />
            <FeatureCard
              Icon={FaQrcode}
              title="Bring your offline world online with QR codes"
              description="Easily link from IRL – your product packaging, posters and flyers – to your online world with a simple QR code."
            />
          </div>

           

          <div className="max-w- mt-10 text-start mx-auto grid grid-cols-1 md:grid-cols-3 gap-4">
            <FeatureCard
              Icon={IoColorPalette}
              title="Grow your followers across all your social platforms"
              description="Give your followers easy access to all of your content in one simple link. Now everything you do is just one tap away!"
            />
            <FeatureCard
              Icon={FaQrcode}
              title="Bring your offline world online with QR codes"
              description="Easily link from IRL – your product packaging, posters and flyers – to your online world with a simple QR code."
            />
            <FeatureCard
              Icon={IoExtensionPuzzleOutline}
              title="Integrate your Digital Twin with your existing tech"
              description="Digital Twin seamlessly connects to other platforms like Mailchimp, Vimeo, Zapier, Amazon, YouTube, Google Analytics, plus more!"
            />
          </div>
        </div> */}  

              {/* <ScrollToTop /> */}
              {/* <div className='hidden lg:inline'>
      <Cookies />
      </div> */}
            <Footer2 />
              
                
    </div>
  );
};

export default Hero;
